<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */
    import { onDestroy, untrack } from 'svelte';
    import settingsKeys from '../../../settings/settingsKeys.js';
    import ControlRow from './generic/ControlRow.svelte';
    import { __ } from '@oat-sa-private/ui-core';

    /**
     * @typedef {Object} Props
     * @property {Object} areaBroker
     * @property {Object} initialState
     * @property {Function} onChange
     */
    /** @type {Props} */
    // prettier-ignore
    let {
        areaBroker,
        initialState,
        onChange
    } = $props();

    // svelte-ignore state_referenced_locally
    const targetElt = areaBroker?.getContainer();

    // these values represent the word-spacing ems
    const min = 0;
    const step = 1 / 12;
    const max = 4 / 12;
    let value = $state(0);

    const initialStateOnce = untrack(() => initialState);
    if (initialStateOnce?.value) {
        handleWordSpacingChange(initialStateOnce);
    }
    let nonDefault = initialStateOnce?.nonDefault;

    /**
     * Handle the input being changed
     * @param {Object} [newState]
     */
    function handleWordSpacingChange(newState = {}) {
        value = newState?.value;
        const wordSpacingValue = `${value}em`;

        targetElt?.style.setProperty('--word-spacing', wordSpacingValue);

        onChange?.({
            key: settingsKeys.wordSpacing,
            state: {
                value,
                wordSpacingValue,
                nonDefault: newState?.nonDefault
            }
        });
    }

    onDestroy(() => {
        targetElt?.style.removeProperty('--word-spacing');
    });
</script>

<ControlRow
    icon="font-spacing-16"
    label={__('Word spacing')}
    {min}
    {max}
    {step}
    {value}
    {nonDefault}
    ariaLabelDecr={__('decrease word spacing')}
    ariaLabelIncr={__('increase word spacing')}
    onChange={handleWordSpacingChange} />
